export const Key_ExpandWidthMessage = 'expand-advisor-width';
export const Key_AdvisorMountedMessage = 'advisor-mounted';
export const Key_CloseActivity = 'close-activity';
export const Key_UpdateOrdersMessage = 'update-orders';
export const Key_SetAdvisorEHRId = 'set-advisor-ehr-id';
export const Key_SetAdvisorWidth = 'set-advisor-width';
//# sourceMappingURL=types.js.map